import React from "react";
import {
  useGetAllAnualRevenueRange,
  useGetAllCompanySize,
  useGetAllIndications,
  useGetAllProviderTypes,
  useGetprovidersListForFilters,
  UseGetRfiListForFilters,
} from "./queries";

export const useRfiListForFilters = () => {
  const {
    data: rfiListForFilters,
    isRfiLoading,
    isRfiError,
  } = UseGetRfiListForFilters();

  return { rfiListForFilters, isRfiLoading, isRfiError };
};

export const useRevenueRange = () => {
  const {
    data: revenueRangeData,
    isLoading: revenueRangeLoading,
    isError: isErrorrevenueRange,
  } = useGetAllAnualRevenueRange();

  return { revenueRangeData, revenueRangeLoading, isErrorrevenueRange };
};

export const useProviderTypes = () => {
  const {
    data: providerTypesFilter,
    isLoading: providerTypesLoading,
    isError: isErrorproviderTypes,
  } = useGetAllProviderTypes();

  return { providerTypesFilter, providerTypesLoading, isErrorproviderTypes };
};

export const useProviderListForFilters = () => {
  const {
    data: providersListForFilters,
    isLoading,
    isError,
  } = useGetprovidersListForFilters();

  return { providersListForFilters, isLoading, isError };
};

export const useIndicationFilter = () => {
  const {
    data: indicationDataFilter,
    isLoading: indicationLoading,
    isError: isErrorIndication,
  } = useGetAllIndications();

  return { indicationDataFilter, indicationLoading, isErrorIndication };
};

export const useComapnySizeData = () => {
  const {
    data: companySizeData,
    isLoading: companySizeLoading,
    isError: isErrorComapnySize,
  } = useGetAllCompanySize();

  return { companySizeData, companySizeLoading, isErrorComapnySize };
};
